/* Variabili globali */
window.isMobile = false;
window.isTablet = false;
window.isTabletPortrait = false;
window.isTabletLandscape = false;
window.isDesktop = false;

/* Funzioni Globali */
var setHeaderHeight = function () {
    if ($('.cc-header').length > 0) {
        var headerHeight = $(document).find('.cc-header__wrp').outerHeight(true);
        document.documentElement.style.setProperty('--headerHeight', headerHeight / 10 + 'rem');
    }
};

var setFooterHeight = function () {
    if ($('.cc-footer').length > 0) {
        var footerHeight = $(document).find('.cc-footer').outerHeight(true);
        document.documentElement.style.setProperty('--footerHeight', footerHeight / 10 + 'rem');
    }
};

var setFullHeight = function () {
    var windowHeight = $(window).innerHeight();
    document.documentElement.style.setProperty('--windowHeight', windowHeight + 'px');
};

var responsiveResize = function () {
    if (window.matchMedia('(max-width: 767.98px)').matches) {
        $('body')
            .addClass('cc-mobile')
            .removeClass('cc-tablet')
            .removeClass('cc-tablet-portrait')
            .removeClass('cc-tablet-landscape')
            .removeClass('cc-desktop');
        window.isMobile = true;
        window.isTablet = false;
        window.isTabletPortrait = false;
        window.isTabletLandscape = false;
        window.isDesktop = false;
    } else if (window.matchMedia('(max-width: 1023.98px)').matches) {
        $('body')
            .removeClass('cc-mobile')
            .addClass('cc-tablet')
            .addClass('cc-tablet-portrait')
            .removeClass('cc-tablet-landscape')
            .removeClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = true;
        window.isTabletPortrait = true;
        window.isTabletLandscape = false;
        window.isDesktop = false;
    } else if (window.matchMedia('(max-width: 1199.98px)').matches) {
        $('body')
            .removeClass('cc-mobile')
            .addClass('cc-tablet')
            .addClass('cc-tablet-landscape')
            .removeClass('cc-tablet-portrait')
            .removeClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = true;
        window.isTabletPortrait = false;
        window.isTabletLandscape = true;
        window.isDesktop = false;
    } else {
        $('body')
            .removeClass('cc-mobile')
            .removeClass('cc-tablet')
            .removeClass('cc-tablet-portrait')
            .removeClass('cc-tablet-landscape')
            .addClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = false;
        window.isTabletPortrait = false;
        window.isTabletLandscape = false;
        window.isDesktop = true;
    }

    setHeaderHeight();
    setFooterHeight();
    setFullHeight();

    // Slider Init
    if ($('.cc-slider').length > 0) {
        $('.cc-slider').each(function () {
            $(this).not('.slick-initialized').slick();
        });
    }
};

window.AOS = require('aos');

$(document).ready(function () {
    responsiveResize();
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';

    // Select
    if ($('.cc-select.selectpicker').length > 0) {
        $('.cc-select.selectpicker').each(function () {
            $(this).selectpicker('refresh');
            const label = $(this).closest('.cc-contentSelect').find('.cc-label').html();
            const selectId = $(this).attr('id');
            const htmlString = '<label class="cc-label cc-visibilityHidden" for="button-' + selectId + '">' + label + '</label>';

            $(this).parent().find('.dropdown-toggle').attr('aria-label', label);
            $(this).parent().find('.dropdown-toggle').attr('aria-controls', 'button-' + selectId);
            $(this).parent().find('.dropdown-menu > .inner').attr('id', 'button-' + selectId);
            $(this).parent().find('.dropdown-menu').prepend(htmlString);
        });
    }

    // Accessibility for slider only mobile
    if ($('.cc-slider').not('.slick-initialized').length > 0) {
        $('.cc-slider').not('.slick-initialized').each(function () {
            $(this).children().removeAttr('aria-hidden tabindex role aria-describedby');
        });
    }

    // Data AOS
    AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 300, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom' // defines which position of the element regarding to window should trigger the animation
    });
    // refresh AOS after images with a lazy loading are loaded
    $('img.cc-imgLazy').on('load', () => AOS.refresh());

    $(window).resize(function () {
        responsiveResize();
    });
});

module.exports = {};
